<span>
  <b>
      {{'change_phone_number.' + type + '.content_title' | translate }}
  </b>
</span>
<span>
  {{'change_phone_number.' + type + '.content' | translate }}
</span>
